import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuitcaseWork: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSuitcaseWork"><Path fillRule="evenodd" clipRule="evenodd" d="M9.75 3.5C9.05964 3.5 8.5 4.05964 8.5 4.75V6H15.5V4.75C15.5 4.05964 14.9404 3.5 14.25 3.5H9.75ZM17 6V4.75C17 3.23122 15.7688 2 14.25 2H9.75C8.23122 2 7 3.23122 7 4.75V6H4.75C3.23122 6 2 7.23122 2 8.75V18.25C2 19.7688 3.23122 21 4.75 21H19.25C20.7688 21 22 19.7688 22 18.25V8.75C22 7.23122 20.7688 6 19.25 6H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSuitcaseWork;
